module.exports = __webpack_public_path__ + "static/postmates.bb4b23c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/logos/postmates.png
// module id = 874
// module chunks = 213534597649335